<template>
  <div v-show="runenv!='miniprogram'">
    <div :class="bgType == 2 ? 'header-bg2' : 'header-bg1'">
      <!-- :class="{'header-mobile':mobileType}" -->
      <div class="header-wrap header-mobile" >
        <div class="row header">
          <div class="relative z-50 nav_left">
            <img class="logo logo1" :src="configData.logo1" v-if="configData.logo1" />
             <img class="logo logo1" src="../assets/images/logo_1.png" v-else />
             <img class="logo logo1" :src="configData.logo2" v-if="configData.logo2"  />
             <img class="logo logo2" src="../assets/images/logo_2.png" v-else />
             

          </div>
          <template v-if="navigationList">
            <!--  v-if="!mobileType" -->
             <ul class="row nav_list nav_wrap">
                <li class="item" v-for="(item, index) in navigationList" :key="index">
                  <div class="item-hover" @click="bindNav(item)">
                    <span class="relative">
                      <span>{{ item.navigationName }}</span>
                      <span class="group-hover"></span>
                    </span>
                  </div>

                  <div
                    class="submenu"
                    v-if="item.subnavigation && item.subnavigation.length"
                  >
                    <ul class="row nav_list">
                      <li
                        class="item"
                        v-for="(child, numb) in item.subnavigation"
                        :key="numb"
                      >
                        <div class="item-hover" @click="bindNav(child)">
                          <span class="relative">
                            <span>{{ child.navigationName }}</span>
                            <span class="group-hover"></span>
                          </span>
                        </div>
                      </li>

                    </ul>
                  </div>
                </li>
              </ul>

              <div class="phone-menu" :class="{'phone-menu_show':mobileMenu}">
                <!-- default-active="2" -->
                <el-menu  class="el-menu-vertical-demo">
                  <template v-for="(item, index) in navigationList" >
                    <el-submenu :index="(index+1).toString()" :key="index" v-if="item.subnavigation && item.subnavigation.length">
                      <span slot="title" >{{item.navigationName}}</span>
                      <el-menu-item :index="(index+1)+'-'+(numb+1)" v-for="(child, numb) in item.subnavigation" :key="index+'-'+numb" @click="bindNav(child)">{{child.navigationName }}</el-menu-item>
                    </el-submenu>
                    <el-menu-item :index="(index+1).toString()" :key="index" v-else  @click="bindNav(item)">
                      <span slot="title">{{item.navigationName}}</span>
                    </el-menu-item>
                  </template>
                  
                </el-menu>
              </div>


          </template>
        
          <div class="rowCenter relative z-50 nav_right">
            <!-- <button
              class="btn btn1"
              @click="toggleLanguage"
              v-loading="langLoad"
            >
              {{ language == "zh" ? "English" : "中文" }}
            </button> -->

            <a :href="'tel:'+configData.contact" class="contact-a text-center btn btn2">{{ $t("contact") }}</a>
            <div class="menu-i" @click="mobileMenu=!mobileMenu">
              <i class="el-icon-close" v-if="mobileMenu"></i> 
              <i class="el-icon-menu" v-else></i>
            </div>
          </div>
        </div>

        <div class="header-bg" :class="{ opacity0: bgOpacity }"></div>
      </div>
      <div class="header-back" v-if="showBg"></div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import {isMobile} from "@/utils/index"
export default {
  name: "headerView",
  props: {
    showBg: {
      type: Boolean,
      default: false,
    },
    bgType: {
      type: Number,
      default: 1, //1黑色、2白色
    },
  },
  components: {},
  computed: {
    ...mapGetters(["language", "navigationList","configData","runenv"]),
  },
  data() {
    return {
      bgOpacity: false,
      stateSche: 1,
      langLoad: false,
      list: [],
      // mobileType:false,
      mobileMenu:false,//菜单列表

    };
  },
  mounted() {
    //  this.mobileType = isMobile()
    this.bgOpacity = !this.showBg;
    if (!this.showBg) {
      window.addEventListener("scroll", this.handleScroll);
    }
    if (!this.navigationList || this.navigationList.length == 0) {
      this.$store.dispatch("GenerateNav").then((res) => {
        this.stateSche = 0;
      });
    }
    if(!this.configData || !this.configData.companyName){
       this.$store.dispatch("GenerateFooter").then((res) => {});
    }

  },
  created() {},
  beforeDestroy() {
    // 移除滚动事件监听
    window.removeEventListener("scroll", this.handleScroll);
  },
  methods: {
    bindNav(item) {
      this.mobileMenu=false;
      let linkUrl = item.pageContent.linkUrl;
      let pageType = item.pageContent.pageType;
      if (pageType == "class") {
        return;
      } else if (pageType == "store") {
        this.$router.push("/store");
      }else if (pageType == "article") {
        this.$router.push("/article");
      } else if(linkUrl) {
        if (/^(https?:|mailto:|tel:)/.test(linkUrl)) {
          window.open(linkUrl);
        } else {
          this.$router.push(linkUrl);
        }
      }
    },
    handleScroll() {
      if (window.scrollY > 4) {
        this.bgOpacity = false;
      } else {
        this.bgOpacity = true;
      }
    },
    toggleLanguage() {
      this.$store.dispatch("toggleLanguage");
      this.$i18n.locale = this.language || "zh";
      this.langLoad = true;
      window.location.reload();
    },

  },

};
</script>
<style scoped lang="scss">
//

.header-wrap {
  width: 100%;
  position: fixed;
  top: 0;
  left: 0;
  z-index: 9;
}
.header-bg {
  transition-delay: 0.4s;
  transition-property: opacity;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 0.15s;
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
}
.opacity0 {
  opacity: 0;
}
.header-wrap:hover .header-bg {
  transition-delay: 0s;
  opacity: 1;
}
.header-back {
  height: 56px;
}
.header {
  font-size: 14px;
  width: 100%;
  height: 56px;
  align-items: center;
  justify-content: space-between;

  padding: 0 45px;
  position: relative;
  z-index: 10;

  .logo {
    height: 28px;
    display: block;
  }
  .logo1,
  .logo2 {
    display: none;
  }
  .nav_wrap {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    line-height: 56px;
    z-index: 30;
  }
  .nav_list {
    justify-content: center;
  }
  .nav_list .item {
    transition-duration: 0.2s;
    transition-property: color, background-color, border-color,
      text-decoration-color, fill, stroke;
    transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
    padding-left: 24px;
    padding-right: 24px;
    cursor: pointer;
    margin-right: 20px;
    white-space: nowrap;
  }
}

.submenu {
  position: absolute;
  top: 56px;
  width: 100%;
  left: 0;
  transition-duration: 0.4s;
  padding: 0 10%;
  height: 0;
  line-height: 78px;
  overflow: hidden;
  .item {
    margin-right: 54px !important;
  }
}

.group-hover {
  transform: translate(0, 0) rotate(0) skewX(0) skewY(0) scaleX(0) scaleY(1);
  transition-duration: 0.3s;
  transition-property: transform;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  width: 100%;
  height: 1px;
  position: absolute;
  transform-origin: top right;
  right: 0;
  left: 0;
  bottom: -10px;
}
.nav_list .item-hover:hover .group-hover {
  transform: translate(0, 0) rotate(0) skewX(0) skewY(0) scaleX(1) scaleY(1);
  transform-origin: top left;
}

.nav_wrap .item:hover .submenu {
  height: 78px;
}

//
.header-bg1 {
  .header-bg {
    background-color: #212122;
  }
  .submenu {
    background-color: rgba(18, 21, 26, 0.6);
  }
  .header {
    color: hsla(0, 0%, 100%, 0.95);
  }
  .btn1 {
    background-color: transparent;
    border-color: #fff;
    color: #fff;
    margin-right: 20px;
  }
  .btn1:hover,
  .btn2 {
    color: #333;
    border-color: #fff;
    background-color: #fff;
  }
  .logo1 {
    display: block;
  }
  .group-hover {
    background-color: hsla(0, 0%, 100%, 0.9);
  }
}

.header-bg2 {
  color: #12151a;
  .header-bg {
    background-color: #fefefe;
  }
  .submenu {
    background-color: rgba(252, 252, 252, 0.9);
  }
  .header {
    color: #212121;
  }
  .btn1 {
    background-color: transparent;
    border-color: #212122;
    color: #212122;
    margin-right: 20px;
  }
  .btn1:hover,
  .btn2 {
    color: #fff;
    border-color: #212122;
    background-color: #212122;
  }
  .logo2 {
    display: block;
  }
  .group-hover {
    background-color: #12151a;
  }
}




// 手机端导航
.phone-menu {
  position: fixed;
  top: 56px;
  width: 0;
  bottom: 0;
  left: 0;
  transition-duration: 0.4s;
  transition-property: width;
  display: none;
  z-index: 99;
  background-color: #fff;
  font-size: 18px;
  overflow-y: scroll;
}
.phone-menu_show {
  display: block;
  width: 100%;
}
.menu-i{
  display: none;
}
.menu-i i{
  font-size: 30px;
}

@media  (min-width: 600px) and (max-width: 980px) {

  .header-back {
    height: 112px;
  }
  .header-bg{
    height: 112px;
  }
  .nav_wrap{top: 56px !important;}


}


@media (max-width: 600px) {
  .header-mobile{
    .header{
        padding: 0 28px;
      }
    }

 .nav_wrap{
  display: none;
 }
 .menu-i{
  display: inline-block;
 }
 .contact-a{
  display: none;
 }


  
}




</style>
<style>
.phone-menu .el-menu-item,.phone-menu .el-submenu__title{
    font-size: 20px;
  }
.phone-menu .el-submenu__icon-arrow{
  font-size: 22px;
}
</style>